<template>
  <ui-container>
    <ui-row align-h="center" v-if="authInfo">
      <ui-spinner v-if="!book" center></ui-spinner>
      <ui-col col="10">
        <ui-heading tag="h4" class="page-title" bold bullet>{{
          $t("createNewBook")
          }}</ui-heading>
      </ui-col>
      <ui-col col="10" v-if="book">
        <ui-card class="card-inner-margin">
          <upload class="mb-3" ref="upload" :max-number="maxNumber" :show-input-after-success="maxNumber > 1" type="drag" file-type="cover" :auto-orient="true" :height="160" :file-list="fileList" @on-success="onSuccess" @on-remove="onRemove" :list-style="maxNumber > 1 ? 'card' : ''">
            <p slot="text">
              {{ $t("uploadBookCover") }}
              <span v-if="maxNumber > 1">({{ $t("canUpload", { number: this.maxNumber }) }})</span>
            </p>
          </upload>
          <ui-v ref="book-form" :rules="rules" class="mb-3">
            <ui-input theme="flat" name="title-input" v-model="book.title" :max-length="180" :placeholder="$t('typeBookTitleHere')" ref="titleInput">
              <ui-icon name="book" slot="prefix"></ui-icon>
            </ui-input>
          </ui-v>
          <ui-textarea class="mb-3" v-model="book.intro" :max-length="380" :placeholder="$t('typeBookIntroHere')" :counter="true">
            <ui-icon name="book" slot="prefix"></ui-icon>
          </ui-textarea>
          <ui-accordion class="mb-3">
            <!-- <ui-accordion-item :title="$t('inviteFriends')" v-if="!book.id">
                  <invite ref="invite"></invite>
                </ui-accordion-item> -->
            <ui-accordion-item :title="$t('advanceSetting')">
              <ui-checkbox v-model="book.isPublic">{{
                $t("isPublic")
                }}</ui-checkbox>
              <ui-checkbox v-model="book.allowCoWrite" toggle>{{
                $t("isAllowCoWrite")
                }}</ui-checkbox>
              <ui-checkbox v-model="showPassword" toggle>{{
                $t("setBookPassword")
                }}</ui-checkbox>
              <transition name="fade">
                <div v-if="showPassword">
                  <ui-hr>
                    <ui-icon name="lock"></ui-icon>
                  </ui-hr>
                  <ui-v ref="password-form">
                    <ui-input v-model="book.password" name="password" ref="passwordInput" icon="lock" :placeholder="
                          book.passwordProtection
                            ? $t('typeNewBookPasswordHere')
                            : $t('typeBookPasswordHere')
                        "><span slot="suffix" @click="genPassword" class="color pointer">{{ $t("randomPassword") }}</span></ui-input>
                  </ui-v>
                </div>
              </transition>
            </ui-accordion-item>
          </ui-accordion>
          <ui-button shadow :loading="loading" full @click="validate">{{
            buttonText
            }}</ui-button>
        </ui-card>
      </ui-col>
    </ui-row>
  </ui-container>
</template>
<script>
import Vue from "vue";
import api from "../api/index";
import { mapGetters } from "vuex";
import { genRandomNum } from "../utils/utils.js";
import beforeUpload from "../mixin/beforeUpload.js";
import config from "../config";
import Upload from "../components/Upload.vue";

export default {
  name: "CreateBook",
  data() {
    return {
      title: "",
      book: null,
      showPassword: false,
      percent: 0,
      isEdit: false,
      loading: false,
      uploadApi2: config[process.env.NODE_ENV].apiPort + "/uploader/upload",
      uploadApi: "",
      data: {},
      headers: api.getHeader().headers,
      rules: {
        "title-input": [{
          type: "required",
          trigger: "submit",
          message: this.$t("empty") + this.$t("title")
        }]
      },
      inviteList: []
    };
  },
  components: {
    Upload
  },
  mixins: [beforeUpload],
  computed: {
    fileList() {
      if (this.book && this.book.cover) {
        return this.book.cover.map(cover => {
          return {
            url: cover,
            status: "finished"
          };
        });
      } else {
        return [];
      }
    },
    buttonText() {
      return this.$route.params.bookId ?
        this.$t("saveBookChanges") :
        this.$t("createBookButton");
    },
    ...mapGetters(["authInfo"]),
    maxNumber() {
      return this.authInfo.role == "user" ? 1 : 6;
    }
  },
  methods: {
    onSuccess({ file }) {
      this.book.fileList = this.$refs["upload"].getId();
    },
    onRemove({ file }) {
      this.book.fileList = [];
    },
    genPassword() {
      this.book.password = genRandomNum(6);
    },
    doPublish() {
      api
        .publishBook(this.book)
        .then(response => {
          let id = response.data.id;
          let code = response.data.code;
          this.$router.push(`/@${this.authInfo.username}/${code}`);
          this.loading = false;
          // if (this.$refs["invite"].inviteList.length) {
          //   this.doInvite(id);
          // }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    updateBook() {
      api
        .updateBook(this.book)
        .then(response => {
          let id = response.data.id;
          let code = response.data.code;
          this.$router.push(`/@${this.authInfo.username}/${code}`);
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    validate() {
      this.$refs["book-form"]
        .validate()
        .then(e => {
          this.publish();
          console.log(e);
        })
        .catch(e => {
          console.log(e);
        });
    },
    publish() {
      if (this.$refs["upload"].isUploading()) {
        this.$UiToast.warning(this.$t("uploadingFile"));
        return;
      }

      if (this.showPassword && !this.book.password) {
        if (!this.book.passwordProtection) {
          this.$refs["password-form"].parseError({ name: 'password', message: this.$t("typePassword") });
          return;
        }
      }
      this.loading = true;
      // this.book.fileList = this.$refs["upload"].getId();
      if (this.book.passwordProtection && !this.showPassword) {
        this.book.removePassword = true;
      }
      if (this.isEdit) {
        this.updateBook();
      } else {
        this.doPublish();
      }
    },
    loadBook(id) {
      api
        .getContentById(id)
        .then(response => {
          let book = response.data.content;
          this.showPassword = book.passwordProtection;
          this.book = book;
        })
        .catch(err => {
          console.log(err);
          //this.$router.push('/index')
        });
    },
    handleProgress({ file }) {}
  },
  mounted() {
    if (this.$route.params.bookId) {
      this.isEdit = true;
      this.book = null;
      this.loadBook(this.$route.params.bookId);
    } else {
      this.book = {
        title: "",
        articleType: "book",
        password: "",
        allowCoWrite: true,
        isPublic: true,
        fileList: []
      };
    }
  }
};

</script>
<style lang="scss">
.ui-upload-container {
  margin: 0;
}

</style>
